module.exports = __webpack_public_path__ + "client/img/invest_03.4ef42620.png";